import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
//import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatChipsModule } from "@angular/material/chips";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { mdiClose, mdiPencil, mdiPlus, mdiRotateRight, mdiTrashCanOutline } from "@mdi/js";

import { DffFormControlModule } from "@dffedb/forms";
import { AccordionStatusIndicatorModule, ImageUploadButtonModule, SpinnerModule } from "@dffedb/ui";
import { SvgIconRegistry } from "@dffedb/util";

import { NoteBilagListeComponent } from "./note-bilag-liste/note-bilag-liste.component";
import { NoteBilagComponent } from "./note-bilag/note-bilag.component";
import { NoteDialog, NoteDialogComponent } from "./note-dialog/note-dialog.component";
import { NoteListeComponent } from "./note-liste/note-liste.component";
import { NoteOpgavestyringComponent } from "./note-opgavestyring/note-opgavestyring.component";
import { NoteComponent } from "./note/note.component";
import { SimpelNoteListeComponent } from "./simpel-note-liste/simpel-note-liste.component";

@NgModule({
    imports: [
        AccordionStatusIndicatorModule,
        CommonModule,
        DffFormControlModule,
        FormsModule,
        ImageUploadButtonModule,
        MatButtonModule,
        MatCardModule,
        MatChipsModule,
        MatDialogModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatProgressSpinnerModule,
        ReactiveFormsModule,
        SpinnerModule
    ],
    exports: [NoteComponent, NoteListeComponent, SimpelNoteListeComponent, NoteDialogComponent],
    declarations: [
        NoteBilagComponent,
        NoteBilagListeComponent,
        NoteComponent,
        NoteDialogComponent,
        NoteListeComponent,
        NoteOpgavestyringComponent,
        SimpelNoteListeComponent
    ],
    providers: [NoteDialog]
})
export class NoteModule {
    constructor(svgIconRegistry: SvgIconRegistry) {
        svgIconRegistry.registerIcon(mdiClose, "close");
        svgIconRegistry.registerIcon(mdiPlus, "plus");
        svgIconRegistry.registerIcon(mdiTrashCanOutline, "trash-can-outline");
        svgIconRegistry.registerIcon(mdiRotateRight, "rotate-right");
        svgIconRegistry.registerIcon(mdiPencil, "pencil");
    }
}
